import { registerChangeClientListenerForForwardAccumulator } from '@/store/forwardAccumulator/listeners/change-client-listener.ts';
import { registerDuplicateForwardAccumulatorTradeCaptureListeners } from '@/store/forwardAccumulator/listeners/duplicate-listener.ts';
import { registerRfsForwardAccumulatorListeners } from '@/store/forwardAccumulator/listeners/rfs-listener.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';

export function registerForwardAccumulatorListeners(startAppListening: StartAppListening): void {
  registerChangeClientListenerForForwardAccumulator(startAppListening);
  registerDuplicateForwardAccumulatorTradeCaptureListeners(startAppListening);
  registerRfsForwardAccumulatorListeners(startAppListening);
}
